module.exports = __webpack_public_path__ + "img/20190615103420466.e5eb88ed.png";